module.exports = __webpack_public_path__ + "img/AL21.55603a7c.webp";